import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainCube = _resolveComponent("MainCube")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MainCube, {
      color: "pink",
      left: "25%",
      top: "12%",
      width: "large",
      height: "xx-large"
    }),
    _createVNode(_component_MainCube, {
      color: "green",
      left: "20%",
      top: "15%",
      width: "xxxx-large",
      height: "large"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      left: "16%",
      top: "72%",
      width: "large",
      height: "large"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      left: "13%",
      top: "75%",
      width: "large",
      height: "large"
    }),
    _createVNode(_component_MainCube, {
      color: "green",
      left: "15%",
      top: "73%",
      width: "medium",
      height: "medium"
    }),
    _createVNode(_component_MainCube, {
      color: "green",
      left: "75%",
      top: "43%",
      width: "large",
      height: "large"
    }),
    _createVNode(_component_MainCube, {
      color: "green",
      left: "78%",
      top: "45%",
      width: "medium",
      height: "medium"
    }),
    _createVNode(_component_MainCube, {
      color: "green",
      right: "0%",
      top: "25%",
      width: "small",
      height: "xx-large"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      right: "0%",
      top: "28%",
      width: "xxx-large",
      height: "medium"
    }),
    _createVNode(_component_MainCube, {
      color: "pink",
      right: "12%",
      top: "84%",
      width: "large",
      height: "xxx-large"
    }),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "loading-screen-box text--center text margin--auto brs--x-large display--flex justify--center align--center" }, [
      _createElementVNode("h1", { class: "text--green title--x-large" }, "טוען... כבר מסיים")
    ], -1))
  ]))
}